const PropTypes = require('prop-types');

module.exports = {
  id: PropTypes.string.isRequired
};
